import { render, staticRenderFns } from "./4_ConfigurarPromocao.vue?vue&type=template&id=7600db5a&"
import script from "./4_ConfigurarPromocao.vue?vue&type=script&lang=js&"
export * from "./4_ConfigurarPromocao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports